import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { useAuth } from '../contexts/AuthContext.js';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../config.js';
import { ScrollTop } from 'primereact/scrolltop';
import { ProgressBar } from 'primereact/progressbar';   
import { Messages } from 'primereact/messages';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import Login from './Login.js';
import { Toast } from 'primereact/toast';
import { InputText as TextInput } from 'primereact/inputtext';
import { canAccessLocationWalletPortal } from '../utils/accessControl';

const SupportTiles = () => {
  // Load the status page script
  useStatusPageScript();
  
  const { id } = useParams();
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const { logout, accessContext } = useAuth();
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    gateName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    tileId: { value: null, matchMode: FilterMatchMode.CONTAINS },
    clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    slave: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [rows] = useState(20);
  const msgs = useRef(null);
  const testmsgs = useRef(null);
  const [troubleShootDialog, setTroubleShootDialog] = useState(false);
  const [lms, setLms] = useState('the LMS');
  const [helpTestTrueHR, setHelpTestTrueHR] = useState(false);
  const [helpTestTrueNor, setHelpTestTrueNor] = useState(false);
  const [helpTestFalse, setHelpTestFalse] = useState(false);
  const [memberTest, setMemberTest] = useState('');
  const [showTestMember, setShowTestMember] = useState(false);
  const [tileId, setTileId] = useState('');
  const [showOptions, setShowOptions] = useState(false);
  const [appid, setAppId] = useState(0);
  const [useAppId, setUseAppId] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const toast = useRef(null);
  const toastBC = useRef(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const editmsgs = useRef(null);
  const [slaveHeader, setSlaveHeader] = useState('Relay');
  const [assignedLocationName, setAssignedLocationName] = useState('your location');
  const isLocationLevelUser = canAccessLocationWalletPortal(accessContext);
  const assignedLocationId = Number(accessContext && accessContext.claims && accessContext.claims.locationId);
  const assignedCustomerId = Number(accessContext && accessContext.claims && accessContext.claims.customerId);

  const handleLoginSuccess = () => {
      setShowLoginModal(false);
      if (toast.current) {
          toast.current.show({severity: 'success', summary: '', detail: 'Login successful! You can continue working.'});
      }
      getEvents(rows, 0);
  };

  useEffect(() => {
    const fetchEvents = async () => {
        if (isLocationLevelUser) {
          resolveLocationName()
            .then((locationName) => {
              if (locationName) setAssignedLocationName(locationName);
            })
            .catch((error) => console.error('Error loading assigned location name:', error));
        }
        getEvents(rows,0);
    };

    let appid = localStorage.getItem('appid'); 
    if(appid !== null){
      setAppId(appid);
      setUseAppId(true);
    }

    fetchEvents();

    let _filters = JSON.parse(localStorage.getItem('tiles-global'));
    if (_filters) {
      setFilters(_filters);
      setGlobalFilterValue(_filters['global'].value);
    }
  }, [accessContext, id, isLocationLevelUser]);

  const resolveLocationName = async () => {
    if (isLocationLevelUser) {
      if (!Number.isFinite(assignedLocationId) || assignedLocationId <= 0) {
        return '';
      }

      const token = localStorage.getItem('token');
      const endpoint = Number.isFinite(assignedCustomerId) && assignedCustomerId > 0
        ? `/support/location/${assignedLocationId}/${assignedCustomerId}`
        : `/locations/${assignedLocationId}`;
      const response = await axios.get(global.config.url + endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const location = Array.isArray(response.data) ? response.data[0] : response.data;
      const locationName = String((location && (location.name || location.locationName)) || '').trim();

      if (locationName) {
        localStorage.setItem('supporttile', locationName);
        localStorage.setItem('supportsite', locationName);
        localStorage.setItem('tilesfrom', 'sites');
      }

      return locationName;
    }

    return localStorage.getItem('supporttile') || localStorage.getItem('supportsite');
  };

  const getEvents = async () => {
    try {
        setLoading(true);
        setEvents([]);
        const token = localStorage.getItem('token');
        const id = localStorage.getItem('id');
        if (isLocationLevelUser) {
          if (!Number.isFinite(assignedLocationId) || assignedLocationId <= 0 || !Number.isFinite(assignedCustomerId) || assignedCustomerId <= 0) {
            msgs.current.show({severity: 'error', summary: '', detail: 'Unable to load your assigned location.'});
            setLoading(false);
            return;
          }

          let locationUrl = global.config.url + `/support/tiles/sites/location/${assignedLocationId}/${assignedCustomerId}`;
          const appid = localStorage.getItem('appid');
          if (appid !== null || useAppId) {
            locationUrl = locationUrl + `?appProviderId=${appid}`;
          }

          const locationResponse = await axios.get(locationUrl, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setEvents(locationResponse.data);
          setLoading(false);
          return;
        }

        let locationame = await resolveLocationName();
        if (!locationame) {
          msgs.current.show({severity: 'error', summary: '', detail: 'Unable to load your assigned location.'});
          setLoading(false);
          return;
        }
        const tilesFrom = isLocationLevelUser ? 'sites' : (localStorage.getItem('tilesfrom') || 'sites');
        let url =  global.config.url + `/support/tiles/${tilesFrom}/${locationame}/${id}`;
        let locname = locationame.split('/');
        if(locname.length > 1){
          locationame = locname[0] + "/" + locname[1];
        }
        else{
          locationame = encodeURIComponent(locname[0]);
        }
        //check if locationame contains spaces and encode it
        if (locationame.includes(' ')) {
          url =  global.config.url + `/support/tiles/${tilesFrom}/${locationame}/${id}`;
        }
        let appid = localStorage.getItem('appid');
        if(appid !== null || useAppId){
          url = url + `?appProviderId=${appid}`;
        }
        const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          let urlLms = global.config.url + `/support/lms/${id}`;
          if(appid !== null || useAppId){
            urlLms = urlLms + `?appProviderId=${appid}`;
          }
          const lms = await axios.get(urlLms, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (lms.status === 200) {
            setLms(lms.data);
            setSlaveHeader(lms.data.key === "Gladstone" ? "Slave" : lms.data.key === "Legend" ? "Gate Number" : "Relay");
          }
          setEvents(response.data);
          setLoading(false);
      } catch (error) {
        console.error('Error fetching event record:', error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            setShowLoginModal(true);
          }
          setLoading(false);
          setEvents([]);
      }
      

    };

  // const onPageChange = (event) => {
  //   setLoading(true);
  //   setRows(event.rows);
  //   getEvents(event.rows, event.page);
  // };
  
  const optionsSelected = (e, rowData) =>{
      // op.current.toggle(e);
      setRowSelectionModel(rowData);
    }

  // const optionsTemplate = (rowData) => {
  //   return <Button link icon="pi pi-ellipsis-v" onClick={(e) => optionsSelected(e, rowData)} />;
  // };

  const getHubandRelay = async () => {
    if(rowSelectionModel[0] === undefined || rowSelectionModel[0].id === 0 || rowSelectionModel[0].name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a tile to view the hub and relay info.'});
    }
    else{
      // navigate(`/accesspoints/client/${rowSelectionModel.name}/${rowSelectionModel.id}`);
      // msgs.current.show({severity: 'info', summary: '', detail: rowSelectionModel.name + ' access points are not yet implemented.'});
      localStorage.setItem('tileid', rowSelectionModel[0].tileId);
      navigate(`/support/hubrelay/`);
    }

  }

  const openTestMember = () => {

    if(rowSelectionModel[0] === undefined || rowSelectionModel[0].id === 0 || rowSelectionModel[0].tileId === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a tile to test it.'});
    }
    else{
      setTileId(rowSelectionModel[0].tileId);
      setShowTestMember(true);
    }
  }

  const getTileLogs = async () => {
        if(rowSelectionModel[0] === undefined || rowSelectionModel[0].id === 0 || rowSelectionModel[0].tileId === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a location to view its clients.'});
    }
    else{
      // navigate(`/accesspoints/client/${rowSelectionModel.name}/${rowSelectionModel.id}`);
      // msgs.current.show({severity: 'info', summary: '', detail: rowSelectionModel.name + ' access clients are not yet implemented.'});

      localStorage.setItem('tilelog', rowSelectionModel[0].tileId);
      navigate(`/support/tilelogs/`);
    }
  }
  const startContent = (
      <React.Fragment>
        <div>
          <Button onClick={() => getHubandRelay()} label="Get Hub and Relay" icon="pi pi-sitemap" className="p-button-success mb-3 ml-3" tooltip="Get hub and relay info for this tile" tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => getTileLogs()} label="Get Tile Logs" icon="pi pi-file" className="p-button mb-3 ml-3" tooltip="Get clients for this location" tooltipOptions={{position:"bottom"}}/>
        </div>
        <div>
          <Button onClick={() => openTestMember()} label="Test Tile" icon="pi pi-check" className="p-button-warning mb-3 ml-3" tooltip="Test this tile using a membership/card number" tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => {setShowEditDialog(true); setShowOptions(false)}} label="Edit Tile" icon="pi pi-pencil" className="p-button-info mb-3 ml-3" tooltip="Edit selected tile" tooltipOptions={{position:"bottom"}}/>
        </div>
      </React.Fragment>
  );

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    localStorage.setItem('tiles-global', JSON.stringify(_filters));

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const clearFilter = () => {
  
  let _filters = { ...filters };
  _filters['global'].value = null;
  setFilters(_filters);
  setGlobalFilterValue('');
  localStorage.removeItem('tiles-global');
};

      const goBack = () => {
  
      localStorage.removeItem('tiles-global');
      navigate(-1);
    }

  const progressbar = (        
    <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
    </div>);

const openHubRelay = () => {
  
  msgs.current.show({severity: 'info', summary: '', detail: 'Hub and Relay are not yet implemented.'});
}

const testMember = async () => {
  if(memberTest === ''){
    msgs.current.show({severity: 'error', summary: '', detail: 'Please enter a member name to test.'});
  }
  else{
    testmsgs.current.show({severity: 'info', summary: '', detail: `Testing member ${memberTest}...`, life: 6000, closeable: false });
    // Here you would implement the logic to test the member
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('id');
    let url = global.config.url + `/support/testmember/${tileId}/${memberTest}/${id}`;
    if(useAppId){
      url = url + `?appProviderId=${appid}`;
    }
    try {
    const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      if(response.status === 200){
        if(response.data === true){
          testmsgs.current.clear();
          testmsgs.current.show({severity: 'success', summary: '', detail: 'Access allowed by lms.'});
        }
        else if(response.data === false){
          testmsgs.current.clear();
          testmsgs.current.show({severity: 'error', summary: '', detail: 'Access denied by lms.'});
            // setHelpTestFalse(true);
        }
        else{
          testmsgs.current.clear();
          testmsgs.current.show({severity: 'warn', summary: '', detail: 'Error testing this tile.'});
        }
      }
      else{
        testmsgs.current.clear();
        testmsgs.current.show({severity: 'warn', summary: '', detail: 'Error testing this tile.'});
      }
    } catch (error) {
      console.error('Error testing member:', error);
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          setShowLoginModal(true);
        }
        testmsgs.current.clear();
        testmsgs.current.show({severity: 'warn', summary: '', detail: 'Error testing this tile.'});
    }
  }
}

const updateAccessPoint = async (newdata) => {
  try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const id = localStorage.getItem('id');
      let url =  global.config.url + `/support/tiles/${newdata.tileId}/${id}/`;
      let appid = localStorage.getItem('appid');
      if(appid !== null || useAppId){
        url = url + `?appProviderId=${appid}`;
      }
      const response = await axios.put(url, newdata, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          toastBC.current.clear();
          getEvents();
          setShowEditDialog(false);
          msgs.current.show({severity: 'success', summary: '', detail: 'Tile updated successfully.'});
        }
        setLoading(false);
    } catch (error) {
      console.error('Error updating tile record:', error);
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          setShowLoginModal(true);
        }
        toastBC.current.clear();
        setShowEditDialog(true);
        setLoading(false);
        editmsgs.current.show({severity: 'error', summary: '', detail: error.response.data || 'Error updating tile.'});
    }
};

const clear = () => {
  toastBC.current.clear();
};

const optionsTemplate = () => {
    return <Button link icon="pi pi-ellipsis-v" onClick={() => {setShowOptions(true);}} />;
  };

const confirmEdit = (newdata) => {
    toastBC.current.show({
      severity: 'info',
      sticky: true,
      className: 'border-none',
      content: (
          <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
              <div className="text-center">
                  <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                  <div className="font-bold text-xl my-3">Are you sure?</div>
              </div>
              <div className="flex align-items-center">
                  <Button onClick={(e) => updateAccessPoint(newdata)} type="button" label="Confirm" className="p-button-success w-6rem" />
                  <Button onClick={(e) => clear(false)} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
              </div>
          </div>
      )
    });
};

const onRowEditComplete = async (e) => {
    let { newData, index } = e;
    let existingTile = events[index];
    let updatedTile = {
      ...existingTile,
      ...newData
    };

    if (newData.controllerPortType === undefined || newData.controllerPortType === null || newData.controllerPortType === '') {
      updatedTile.controllerPortType = existingTile.controllerPortType;
    }

    let aps = [...events];
    aps[index] = updatedTile;
    setEvents(aps);
    confirmEdit(updatedTile);
  };

const logoutUser = async () => {
    await logout();
    navigate('/login');
  }

  const textEditor = (options) => {
      return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    };

    const editTileDialogFooter = (
          <div className='flex justify-content-center mb-3'>
            <Button label="Cancel" icon="pi pi-times" className="p-button-warning" onClick={() => setShowEditDialog(false)} tooltip="Cancel changes" tooltipOptions={{position:"bottom"}}/>
            <Button label="Save Changes" icon="pi pi-check" className="p-button-success" onClick={() => {onRowEditComplete({newData: rowSelectionModel[0], index: events.findIndex(x => x.tileId === rowSelectionModel[0].tileId)});}} tooltip="Save changes" tooltipOptions={{position:"bottom"}}/>
          </div>  
        );
  return (
    <Card className='justify-content-md-center mt-5'>
      <Container fluid="md" >
      <div className="panel">
        <div className="flex align-content-center flex-wrap">
          {!isLocationLevelUser && <Button link icon="pi pi-arrow-left" onClick={() => goBack()} className='flex mb-3'/>}
          <h4 className='flex mt-2 mb-3'>Tiles for {isLocationLevelUser ? assignedLocationName : localStorage.getItem("supporttile").split('/')[0]}</h4> 
          <span className="p-input-icon-left mb-3 ml-3">
            <i className="pi pi-search" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filter Search" tooltip="Start typing to filter" 
              tooltipOptions={{position: "bottom"}}/>

          </span>
          <Button icon="pi pi-times" className="p-button-text mb-3"  onClick={() => clearFilter()} tooltip="Clear filter" tooltipOptions={{position: "bottom"}} />
        </div>
        
        {/* <Toolbar           
        start={

        } 
        end = {        
          }/> */}
      </div>
      {loading && progressbar}
        <Messages ref={msgs} />
        <Toast ref={toast} />
        <Toast ref={toastBC} position="top-center" />
        <Row className='justify-content-md-center mt-5'>
            <Col>
            {!isLocationLevelUser && <Dialog visible={showOptions} onHide={() => setShowOptions(false)} style={{ minWidth: '5rem' }}>
              {startContent}
            </Dialog>}
            <DataTable value={events} selectionMode={'radiobutton'} selection={rowSelectionModel} onSelectionChange={(e) => optionsSelected(e, e.value)} 
            onClick={isLocationLevelUser ? undefined : () => setShowOptions(true)} editMode='row' onRowEditComplete={onRowEditComplete}
            dataKey="gateName" tableStyle={{ minWidth: '70rem' }} filters={filters} filterDisplay="menu" emptyMessage={loading ? "Loading tiles..." : "No tiles found."}
            globalFilterFields={['gateName', 'tileId', 'clientName', 'slave']}  
            scrollable scrollHeight="60vh">
                {/* <Column field="options" header="Options" body={optionsTemplate} onClick={(e) => console.log(e)}> </Column> */}
                {/* <Column rowEditor headerStyle={{ width: '5%', minWidth: '1rem' }} bodyStyle={{ textAlign: 'center' }} onClick={()=>setShowOptions(false)}></Column> */}
                <Column field="gateName" header="Name" showFilterMenu={false} filterMenuStyle={{ width: '10rem' }} style={{ minWidth: '8rem' }} sortable ></Column>
                <Column field="tileId" header="Tile ID" showFilterMenu={false} filterMenuStyle={{ width: '10rem' }} style={{ minWidth: '8rem' }} sortable></Column>
                <Column field="clientName" header="Client Name" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} sortable></Column>
                <Column field="slave" header={slaveHeader} showFilterMenu={false} filterMenuStyle={{ width: '4rem' }} style={{ minWidth: '4rem' }} sortable ></Column>
                {lms.key === "Gladstone" && (<Column field="prefix"  header="Prefix" showFilterMenu={false} filterMenuStyle={{ width: '4rem' }} style={{ minWidth: '4rem' }} sortable ></Column>)}
                {lms.key === "Gladstone" && (<Column field="lmsPort"  header="LMS Port" showFilterMenu={false} filterMenuStyle={{ width: '4rem' }} style={{ minWidth: '4rem' }} sortable ></Column>)}
                {lms.key === "Gladstone" && (<Column field="lmsPortType" header="LMS Type" showFilterMenu={false} filterMenuStyle={{ width: '4rem' }} style={{ minWidth: '4rem' }} sortable ></Column>)}
                {lms.key === "Gladstone" && (<Column field="controllerPort"  header="Controller Port" showFilterMenu={false} filterMenuStyle={{ width: '4rem' }} style={{ minWidth: '4rem' }} sortable ></Column>)}
                {lms.key === "Gladstone" && (<Column field="controllerPortType" header="Controller Type" showFilterMenu={false} filterMenuStyle={{ width: '4rem' }} style={{ minWidth: '4rem' }} sortable ></Column>)}
                <Column field="barcodeReaderPort"  header="Barcode Reader Port" showFilterMenu={false} filterMenuStyle={{ width: '4rem' }} style={{ minWidth: '4rem' }} sortable ></Column>
            </DataTable>
            </Col>

        </Row>
        <br></br>
        <p className="text-center">LMS type 0: Cloud LMS, LMS type 1: Gladstone access, LMS type 2: Gladstone Check-in/Member Info</p>
        <p className="text-center">Controller type 0: Hub and Relay, Controller type 1: Door Controller (e.g. Nortech), Controller type 2: always when version 1.7.1</p>

            {rowSelectionModel[0] !== undefined && (
              <div className="card flex justify-content-center mt-3 mb-3">
                <Dialog className='' visible={showEditDialog} onHide={() => setShowEditDialog(false)} footer={editTileDialogFooter} >
                  <Messages ref={editmsgs} />
                  <div className="card">
                    <Toolbar className='' start={<h4>Edit Tile {rowSelectionModel[0].tileId} - {rowSelectionModel[0].gateName}</h4>}/>
                  </div>
                  <div className='justify-content-md-center mt-5 mb-3 '>
                    <label className='mr-3'>Slave Number:</label>
                    <TextInput className='mr-3' value={rowSelectionModel[0].slave} onChange={(e) => setRowSelectionModel([{...rowSelectionModel[0], slave: e.target.value}])} placeholder="Slave Number"/>
                  </div>
                  {lms.key === "Gladstone" && (<div className='justify-content-md-center mb-3' visible={lms === "Gladstone"}>
                    <label className='mr-3'>Prefix:</label>
                    <TextInput value={rowSelectionModel[0].prefix} onChange={(e) => setRowSelectionModel([{...rowSelectionModel[0], prefix: e.target.value}])} placeholder="Prefix"/>
                  </div> )}
                  {lms.key === "Gladstone" && (<div className='justify-content-md-center mb-3' visible={lms === "Gladstone"}>
                    <label className='mr-3'>LMS Port:</label>
                    <TextInput className='mr-3' value={rowSelectionModel[0].lmsPort} onChange={(e) => setRowSelectionModel([{...rowSelectionModel[0], lmsPort: e.target.value}])} placeholder="LMS Port"/>
                  </div> )}
                  {lms.key === "Gladstone" && (<div className='justify-content-md-center mb-3' visible={lms === "Gladstone"}>
                    <label className='mr-3'>LMS Port Type:</label>
                    <TextInput className='' value={rowSelectionModel[0].lmsPortType} onChange={(e) => setRowSelectionModel([{...rowSelectionModel[0], lmsPortType: e.target.value}])} placeholder="LMS Port Type"/>
                    <Button className='p-button-text' rounded  icon="pi pi-info-circle" tooltip="LMS type 0: Cloud LMS, LMS type 1: Gladstone access, LMS type 2: Gladstone Check-in/Member Info" tooltipOptions={{position:"bottom"}}/>
                  </div> )}
                  {lms.key === "Gladstone" && (<div className='justify-content-md-center mb-3' visible={lms === "Gladstone"}>
                    <label className='mr-3'>Controller Port:</label>
                    <TextInput value={rowSelectionModel[0].controllerPort} onChange={(e) => setRowSelectionModel([{...rowSelectionModel[0], controllerPort: e.target.value}])} placeholder="Controller Port"/>
                  </div> )}
                  {lms.key === "Gladstone" && (<div className='justify-content-md-center mb-3' >
                    <label className='mr-3'>Controller Port Type:</label>
                    <TextInput value={rowSelectionModel[0].controllerPortType} onChange={(e) => setRowSelectionModel([{...rowSelectionModel[0], controllerPortType: e.target.value}])} placeholder="Controller Port Type"/>
                    <Button className='p-button-text' rounded  icon="pi pi-info-circle" tooltip="Controller type 0: Hub and Relay, Controller type 1: Door Controller (e.g. Nortech), Controller type 2: always when version 1.7.1" tooltipOptions={{position:"bottom"}}/>
                  </div> )}
                  <div className='justify-content-md-center mb-3'>
                    <label className='mr-3'>Barcode Reader Port:</label>
                    <TextInput value={rowSelectionModel[0].barcodeReaderPort} onChange={(e) => setRowSelectionModel([{...rowSelectionModel[0], barcodeReaderPort: e.target.value}])} placeholder="Barcode Reader Port"/>
                  </div>
                </Dialog>
              </div>
            )}

        {/* <Button label="Troubleshoot" icon="pi pi-wrench" className="p-button-warning mb-3 ml-3" onClick={() => setTroubleShootDialog(true)} tooltip="Open Troubleshoot guide" tooltipOptions={{position:"bottom"}}/> */}
        {/* <OverlayPanel ref={op}>
            {startContent}
          </OverlayPanel> */}
          <div className="card flex justify-content-center">
            <Dialog className='justify-content-center' visible={troubleShootDialog} onHide={() => setTroubleShootDialog(false)}>
            <div className="card">
              <Toolbar className='' start={<h4>Troubleshoot guide</h4>}/>
              </div>
            <div className='justify-content-md-center mt-5'>
              <React.Fragment>
                <ul>
                <li> Got to C:\ProgramData\CCTech\SmartTile\Client\st-event.log and check that Smart Tile is receiving the scans if not, restart Smart Tile Client service. </li>
                  <li>If Smart Tile still does not receive the scans, check the network connection and that SmartTile server's URL has been added to the Firewall (http://mfapi.smarttile.co.uk) </li>
                  <li> If Smart Tile is receiving the scans but not getting into {lms} please restart {lms}</li>
                  <li> If after restarting {lms} it still does not receive the scans. Check that the cables are correctly connected. </li>
                  <li> If they are, please check the COM ports in Device Manager match with the one set in {lms} and the ones set in Smart Tile (<a href='/support/tiles'>see tiles page</a> for more details)</li>
                  <li> Another good practice would be to restart the PC in case the COM ports are frozen.</li>
                  <li> If {lms} is receiving the scans correctly but the gate is not opening, check that we are receiving the open gate commands in C:\ProgramData\CCTech\SmartTile\Client\st-event.log</li>
                  <li> If we are not receiving them restart Smart Tile Client and/or check the access rules in {lms}</li>
                  <li> If we are receiving them, there could be a problem with the controller, check that it is running correctly; if hub and relay please hub and relays status for these clients <a href="/" onClick={() => openHubRelay()}>here</a>.</li>
                  {appid == 2 && (<li> If the problem still persists, please use the ‘live chat function’ in your app's Cockpit. Click here for instructions on how to do this - <a href="https://eur06.safelinks.protection.outlook.com/?url=https%3A%2F%2Frb.gy%2Flbwdhi&data=05%7C02%7Cmatt%40innovatise.com%7Cf199dfb149f74d94670708dd200b11bd%7C791dcfc4e7f34e3988270ba4d9b33c8e%7C0%7C0%7C638701954098698861%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=U22nSxVAQIMw1rRl6dw0rCR5J3sx1vn8jrgz%2BxBLkR0%3D&reserved=0" target="_blank">Click here for instructions</a></li>)}
                  {appid != 2 && (<li> If the problem still persists, please contact support@smarttile.co.uk </li>)}
                </ul>
                {/* <Button label="Open Support Ticket" icon="pi pi-ticket" className="p-button-success mb-3 ml-3" onClick={() => navigate('/support/tickets/create')} tooltip="Open a support ticket for this client" tooltipOptions={{position:"bottom"}}/> */}
              </React.Fragment>
            </div>
            </Dialog>
          <Dialog className='justify-content-center' visible={showTestMember} onHide={() => setShowTestMember(false)} style={{ minWidth: '5rem' }}>
          <div className="card">
            <Toolbar className='' start={<h4>Test tile {tileId}</h4>}/>
            </div>
            <div className='justify-content-md-center mt-5'>

            <Messages ref={testmsgs} />
            <React.Fragment>
              {/* <Dropdown placeholder="Select tile" options={tiles} optionLabel="name" optionValue="gatename" className="mb-3" onChange={(e) => setTileId(e.tileId)} /> */}
              <div className='mt-3'>
              <InputText value={memberTest} onChange={(e) => setMemberTest(e.target.value)} placeholder="Enter member number to test"/>
              </div>
              <div className='mt-3'>
              <Button label="Test Member" icon="pi pi-check" className="p-button-success" onClick={() => {testMember()}} tooltip="Test member access" tooltipOptions={{position:"bottom"}}/>

              </div>
              {/* <Button label="Open Support Ticket" icon="pi pi-ticket" className="p-button-info mt-3" onClick={() => navigate('/support/tickets/create')} tooltip="Open a support ticket for this client" tooltipOptions={{position:"bottom"}}/> */}
            </React.Fragment>
          </div>
          </Dialog>
                      <Dialog className='justify-content-center' visible={helpTestFalse} onHide={() => setHelpTestFalse(false)} onOpenChange={(open) => {
                        if (!open) navigate('support/tiles'); // close dialog
                      }} style={{ minWidth: '5rem' }}>
                      <div className="card">
                        <Toolbar className='' start={<h4>Test not successful</h4>}/>
                        </div>
                      <div className='justify-content-md-center mt-5'>
                        <React.Fragment>
                          <p> The test was not successful, please restart Smart Tile Client service and {lms} and try again, if still not successful, see below:</p>
                          <ul>
                            <li> Check if the scan appeared in {lms}</li>
                              <ul>
                                <li> If not please run the installer and make sure that the COM ports are correctly setup according device manager and check that the slave/gate number match with the ones set in {lms}</li>
                              </ul>
                            <li> If the scan appeared in {lms} but access denied</li>
                            <ul>
                              <li> Check the access rules for this member are correctly setup</li>
                            </ul>
                          </ul>
                          {appid == 2 && (<p> If the issue persists, please use the ‘live chat function’ in your app's Cockpit. Click here for instructions on how to do this - <a href="https://eur06.safelinks.protection.outlook.com/?url=https%3A%2F%2Frb.gy%2Flbwdhi&data=05%7C02%7Cmatt%40innovatise.com%7Cf199dfb149f74d94670708dd200b11bd%7C791dcfc4e7f34e3988270ba4d9b33c8e%7C0%7C0%7C638701954098698861%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=U22nSxVAQIMw1rRl6dw0rCR5J3sx1vn8jrgz%2BxBLkR0%3D&reserved=0" target="_blank">Click here for instructions</a></p>)}
                          {appid != 2 && (<p> If the issue persists, please contact support@smarttile.co.uk </p>)}  
                          {/* <Button label="Open Support Ticket" icon="pi pi-ticket" className="p-button-success mb-3 ml-3" onClick={() => navigate('/support/tickets/create')} tooltip="Open a support ticket for this client" tooltipOptions={{position:"bottom"}}/> */}
                        </React.Fragment>
                      </div>
                      </Dialog>
                      <Dialog className='justify-content-center' visible={helpTestTrueNor} onHide={() => setHelpTestTrueNor(false)} style={{ minWidth: '5rem' }}>
                      <div className="card">
                        <Toolbar className='' start={<h4>Test successful</h4>}/>
                        </div>
                      <div className='justify-content-md-center mt-5'>
                        <React.Fragment>
                          <p> The test was successful, please check that it has released the gate. </p>
                          <p> If the gate did not release, please use the URI test to test if the door controller releases and, also, to check the slave number that triggers the gate.</p>
                          <p> If the slave number is different that the one set for this accesspoint, you can change it in our end using the installer and you might also need to change it in {lms}.</p>
                        </React.Fragment>
                      </div>
                      </Dialog>
                      <Dialog className='justify-content-center' visible={helpTestTrueHR} onHide={() => setHelpTestTrueHR(false)} style={{ minWidth: '5rem' }}>
                      <div className="card">
                        <Toolbar className='' start={<h4>Test successful</h4>}/>
                        </div>
                      <div className='justify-content-md-center mt-5'>
                        <React.Fragment>
                          <p> The test was successful, please check that it has released the gate. </p>
                          <p> If the gate did not release, please check if the hub and/or relay are online.</p>
                          <p> You can check if the hub and/or the relay are online <a href='/support/hubrelay'>here</a>.</p>
                        </React.Fragment>
                      </div>
                      </Dialog>
          </div>
          <div className="card flex justify-content-center">
            <Dialog 
              header="Session Expired - Please Login Again" 
              visible={showLoginModal} 
              style={{ width: '450px' }} 
              modal={true}
              closable={false}
              className="justify-content-center"
            >
              <p className="mb-3">Your session has expired. Please log in again to continue working without losing your form data.</p>
              <div className="flex justify-content-center">
                <Login onLoginSuccess={handleLoginSuccess} />
              </div>
            </Dialog>
          </div>
      </Container>
    <ScrollTop />
    </Card>
  );
};

export default SupportTiles;
